import { useEffect, useRef, useState } from "react";
import { Calendar } from "lucide-react";
import { toDMY, fromDMY } from "../lib/units";

const dash = (t) => {
  const d = t.replace(/[^\d]/g, "").slice(0, 8);
  return d.length > 4 ? `${d.slice(0, 2)}-${d.slice(2, 4)}-${d.slice(4)}` : d.length > 2 ? `${d.slice(0, 2)}-${d.slice(2)}` : d;
};

// Drop-in for <input type="date">: shows/accepts DD-MM-YYYY, emits ISO (YYYY-MM-DD) via onChange({ target: { value } }).
export function DateInput({ value, onChange, min, max, required, className = "", ...rest }) {
  const pick = useRef(null);
  const [txt, setTxt] = useState(toDMY(value));
  useEffect(() => setTxt(toDMY(value)), [value]);
  const emit = (iso) => onChange?.({ target: { value: iso } });
  const commit = (t) => {
    const iso = fromDMY(t);
    if (iso && (!min || iso >= min) && (!max || iso <= max)) { if (iso !== value) emit(iso); setTxt(toDMY(iso)); return; }
    if (!t && !required) { emit(""); return; }
    setTxt(toDMY(value));
  };
  return (
    <span className={`date-input ${className}`}>
      <input {...rest} type="text" inputMode="numeric" placeholder="DD-MM-YYYY" value={txt} required={required} autoComplete="off"
        onChange={(e) => { const t = /^\d{4}-/.test(e.target.value) ? e.target.value : dash(e.target.value); setTxt(t); if (t.length === 10) commit(t); }}
        onBlur={() => commit(txt)} />
      <button type="button" className="date-input-btn" tabIndex={-1} aria-label="Open calendar" onClick={() => { try { pick.current?.showPicker(); } catch { pick.current?.focus(); } }}><Calendar size={14} /></button>
      <input ref={pick} type="date" className="date-input-native" tabIndex={-1} aria-hidden="true" value={value || ""} min={min} max={max} onChange={(e) => emit(e.target.value)} />
    </span>
  );
}
